/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VideoCallProviderEnum } from './videoCallProviderEnum';
import { BookableAppointmentType } from './bookableAppointmentType';
import { Language } from './language';
import { AdministrativeDivision } from './administrativeDivision';


import {ValidatorFn, Validators} from "@angular/forms";

export interface UserAppointmentResource { 
    readonly id: number;
    readonly administrativeDivision: AdministrativeDivision | null;
    readonly bookableAppointmentTypes: Array<BookableAppointmentType>;
    readonly defaultVideoCallProvider: VideoCallProviderEnum;
    readonly videoCallProviderUserId: string;
    /**
     * Doctolib \'Terminkalender\' name. Maps 1:1 to this resource for CSV matching.
     */
    readonly doctolibAgendaLabel: string | null;
    readonly spokenLanguages: Array<Language>;
}
export namespace UserAppointmentResource {
}

export const UserAppointmentResource_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserAppointmentResource_administrativeDivision_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserAppointmentResource_bookableAppointmentTypes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserAppointmentResource_defaultVideoCallProvider_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserAppointmentResource_videoCallProviderUserId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserAppointmentResource_doctolibAgendaLabel_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserAppointmentResource_spokenLanguages_Validators: ValidatorFn[] =
    [  Validators.required, ];


